import { AuctionDetailsModulesComponent } from './../components/adservices/auction/auction-details-modules.component';
import { AuctionDetailsAdaptersComponent } from './../components/adservices/auction/auction-details-adapters.component';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { AuthGuard } from '../guards/auth.guard';
import { PermissionGuard } from '../guards/permission.guard';
import { RedirectGuard } from './../guards/redirect.guard';

import { SharedModule } from './shared.module';
import { BbTableModule } from './bb-table.module';
import { PipesModule } from './pipes.module';

import { AdservicesComponent } from './../components/adservices/adservices.component';
import { VastListComponent } from './../components/adservices/vastservice/vast-list.component';
import { VastDetailsComponent } from './../components/adservices/vastservice/vast-details.component';
import { VastDetailsMetadataComponent } from './../components/adservices/vastservice/vast-details-metadata.component';
import { VastDetailsEndscreenComponent } from '../components/adservices/vastservice/vast-details-endscreen.component';
import { AdPositionListComponent } from '../components/adservices/positions/ad-position-list.component';
import { AdPositionDetailsComponent } from '../components/adservices/positions/ad-position-details.component';
import { AdScheduleListComponent } from './../components/adservices/adschedule/adschedule-list.component';
import { AdScheduleDetailsComponent } from './../components/adservices/adschedule/adschedule-details.component';
import { AdScheduleDetailsMetadataComponent } from './../components/adservices/adschedule/adschedule-details-metadata.component';
import { AdunitDetailsPrebidComponent } from './../components/adservices/adunit/adunit-details-prebid.component';
import { AuctionListComponent } from './../components/adservices/auction/auction-list.component';
import { AuctionDetailsComponent } from './../components/adservices/auction/auction-details.component';
import { AuctionDetailsGeneralComponent } from './../components/adservices/auction/auction-details-general.component';

import { NavigateAwayGuard } from '../components/shared/abstract-details.component';
import { BbAdservicesMenuComponent } from './../components/adservices/bb-adservices-menu.component';
import { LineitemListComponent } from '../components/adservices/lineitem/lineitem-list.component';
import { LineitemDetailsComponent } from '../components/adservices/lineitem/lineitem-details.component';
import { LineitemDetailsSettingsComponent} from '../components/adservices/lineitem/lineitem-details-settings.component';

import { AdunitListComponent } from '../components/adservices/adunit/adunit-list.component';
import { AdunitDetailsComponent } from '../components/adservices/adunit/adunit-details.component';
import { AdunitDetailsGeneralComponent } from '../components/adservices/adunit/adunit-details-general.component';
import { AdunitQuickeditComponent } from '../components/adservices/adunit/adunit-quickedit.component';
import { LineitemQuickeditComponent } from '../components/adservices/lineitem/lineitem-quickedit.component';
import { VastDetailsReactComponent } from 'app/components/adservices/vastservice/vast-details-react.component';
import { AdDashboardComponent } from 'app/components/adservices/dashboard/ad-dashboard.component';
import { AdDashboardOutstreamComponent } from 'app/components/adservices/dashboard/ad-dashboard-outstream.component';
import { AdDashboardInstreamComponent } from 'app/components/adservices/dashboard/ad-dashboard-instream.component';
import { AdDashboardAdschedulesComponent } from 'app/components/adservices/dashboard/ad-dashboard-adschedules.component';

const moduleRoutes: Routes = [
	{
		path: 'adservices',
		component: AdservicesComponent,
		canActivate: [AuthGuard, PermissionGuard],
		data: {
			permissions: ['ad services']
		},
		children: [
			{ path: 'dashboard', redirectTo: 'dashboard/outstream', pathMatch: 'full' },
			{ path: 'dashboard/:tab', component: AdDashboardComponent, data: { permissions: ['root'] }, canActivate: [PermissionGuard] },
			{ path: 'vastservice', component: VastListComponent, data: {class: 'has-sidebar has-header'} },
			{ path: 'vastservice/creatives/:id', redirectTo: 'vastservice/creatives/:id/metadata', pathMatch: 'full' },
			{ path: 'vastservice/creatives/:id/:tab', component: VastDetailsComponent, canDeactivate: [NavigateAwayGuard] },
			{ path: 'positions', component: AdPositionListComponent, data: {class: 'has-sidebar has-header'} },
			{ path: 'position/playout/:id', component: AdPositionDetailsComponent },
			{ path: 'adschedules', component: AdScheduleListComponent, data: {
				permissions: ['adschedules'],
				class: 'has-sidebar has-header'
			}, canActivate: [PermissionGuard]
			},
			{ path: 'adschedule/:id', redirectTo: 'adschedule/:id/metadata', pathMatch: 'full' },
			{ path: 'adschedule/:id/:tab', component: AdScheduleDetailsComponent, data: {
				permissions: ['adschedules'],
			}, canActivate: [PermissionGuard], canDeactivate: [NavigateAwayGuard]
			},
			{ path: 'auctions', component: AuctionListComponent, data: {
				permissions: ['auctions'],
				class: 'has-sidebar has-header'
			}, canActivate: [PermissionGuard]
			},
			{ path: 'auction/:id', redirectTo: 'auction/:id/general', pathMatch: 'full' },
			{ path: 'auction/:id/:tab', component: AuctionDetailsComponent, data: {
				permissions: ['auctions'],
			}, canActivate: [PermissionGuard], canDeactivate: [NavigateAwayGuard]
			},
			{ path: 'lineitems', component: LineitemListComponent, data: {class: 'has-sidebar has-header'} },
			{ path: 'lineitems/:id', redirectTo: 'lineitems/:id/settings', pathMatch: 'full' },
			{ path: 'lineitems/:id/:tab', component: LineitemDetailsComponent, canActivate: [RedirectGuard], canDeactivate: [NavigateAwayGuard] },
			{ path: 'adunits', component: AdunitListComponent, data: {class: 'has-sidebar has-header'} },
			{ path: 'adunits/:id', redirectTo: 'adunits/:id/general', pathMatch: 'full' },
			{ path: 'adunits/:id/:tab', component: AdunitDetailsComponent, canDeactivate: [NavigateAwayGuard] }
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(moduleRoutes),
		CommonModule,
		SharedModule,
		PipesModule,
		FormsModule,
		BbTableModule
	],
	declarations: [
		AdDashboardComponent,
		AdDashboardOutstreamComponent,
		AdDashboardInstreamComponent,
		AdDashboardAdschedulesComponent,
		AdservicesComponent,
		AdunitDetailsPrebidComponent,
		VastListComponent,
		VastDetailsComponent,
		VastDetailsMetadataComponent,
		VastDetailsEndscreenComponent,
		VastDetailsReactComponent,
		AdPositionListComponent,
		AdPositionDetailsComponent,
		AdScheduleListComponent,
		AdScheduleDetailsComponent,
		AdScheduleDetailsMetadataComponent,
		AuctionListComponent,
		AuctionDetailsComponent,
		AuctionDetailsGeneralComponent,
		AuctionDetailsModulesComponent,
		AuctionDetailsAdaptersComponent,
		LineitemListComponent,
		LineitemDetailsComponent,
		LineitemDetailsSettingsComponent,
		AdunitListComponent,
		AdunitDetailsComponent,
		AdunitDetailsGeneralComponent,
		AdunitQuickeditComponent,
		LineitemQuickeditComponent
	],
	exports: [
		AdDashboardComponent,
		AdDashboardOutstreamComponent,
		AdDashboardInstreamComponent,
		AdDashboardAdschedulesComponent,
		AdservicesComponent,
		AdunitDetailsPrebidComponent,
		VastListComponent,
		VastDetailsComponent,
		VastDetailsMetadataComponent,
		VastDetailsEndscreenComponent,
		VastDetailsReactComponent,
		AdPositionListComponent,
		AdPositionDetailsComponent,
		AdScheduleListComponent,
		AdScheduleDetailsComponent,
		AdScheduleDetailsMetadataComponent,
		AuctionListComponent,
		AuctionDetailsComponent,
		AuctionDetailsGeneralComponent,
		AuctionDetailsModulesComponent,
		AuctionDetailsAdaptersComponent,
		LineitemListComponent,
		LineitemDetailsComponent,
		LineitemDetailsSettingsComponent,
		AdunitListComponent,
		AdunitDetailsComponent,
		AdunitDetailsGeneralComponent,
		AdunitQuickeditComponent,
		LineitemQuickeditComponent
	],
	providers: [
		BbAdservicesMenuComponent
	]
})

export class AdservicesModule {
}
